<template>
    <div class="footer">
        <div class="container">
            <div class="row">
                <div class="ft_lx">
                    <h3>Contact Us</h3>
                    <strong>+86 4009-710-788</strong>
                    <ul class="l_x">
                        <li><i class="iconfont icon-dizhi4"></i>#333 ANKANG ROAD, HIGH-TECH ZONE, BINZHOU, SHANDONG,
                            CHINA</li>
                        <li><i class="iconfont icon-youxiang"></i>info@cnhonorgroup.com</li>
                    </ul>
                </div>
                <div class="ft_dh">
                    <div class="ft_fl" v-for="(item, index) in typeDataFive" :key="index">
                        <h3 @click="nowIndex = index === nowIndex ? -1 : index;">{{ item.value }}<em></em></h3>
                        <div class="l_b home_footer-list">
                            <p v-for="(item2, index2) in item.data" :key="index2"><a
                                    :href="`/products?type=${item2.id}`">{{ item2.value }}</a></p>
                        </div>
                        <div class="l_b home_footer-list2" v-show="nowIndex == index">
                            <p v-for="(item2, index2) in item.data" :key="index2"><a
                                    :href="`/products?type=${item2.id}`">{{ item2.value }}</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="banquan">
            <div class="container">Copyright © {{ new Date().getFullYear() }} CNHONOR GROUP. All rights reserved</div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'Footer',
    data() {
        return {
            nowIndex: -1,
        }
    },
    computed: {
        ...mapState(['productTypes']),
        typeDataFive() {
            return this.productTypes.slice(0, 5);
        },
    }
}
</script>

<style>
@media only screen and (min-width:1340px) {
    .home_footer-list {
        display: block;
    }

    .home_footer-list2 {
        display: none;
    }
}

@media only screen and (max-width:640px) {
    .home_footer-list {
        display: none;
    }
}
</style>